import React, { useEffect, useState } from "react";
import { Slang, SlangObj } from "../../helpers";
import { Link } from "react-router-dom";
import LangSwitcher from "../langSwitcher";
import DropDown from "../dasboard/dropDown";
import { useSelector } from "react-redux";
import { FaShoppingCart } from "react-icons/fa";
import { BsSearch } from "react-icons/bs";
// import { ShoppingCart } from "@material-ui/icons";

const NavBar = ({ transparent = false, sub = false }) => {
  const lang = Slang("navbar");
  const isAuth = useSelector((state) => state.auth.isAuth);
  const objLang = Array.isArray(SlangObj("navbar.categlist"))
    ? SlangObj("navbar.categlist")
    : Object.values(SlangObj("navbar.categlist"));

  const [pathName, setPathName] = useState("");

  const cart = useSelector((state) => state.cart.cart);
  console.log(cart);

  const getTotalQuantity = () => {
    let total = 0;
    cart.forEach((item) => {
      total += item.quantity;
    });

    return total;
  };

  useEffect(() => {
    setPathName(window.location.pathname);
  }, []);

  return (
    <header
      id="header"
      className={`navbar navbar-expand-lg navbar-floating navbar-end navbar-light bg-${
        transparent ? "transparent" : "tertiary"
      } container`}
    >
      <div className="container">
        <nav className="js-mega-menu navbar-nav-wrap">
          <Link className="navbar-brand" to="/" aria-label="Front">
            <img
              className="navbar-brand-logo"
              src={`${(sub = "market-place"
                ? "../../assets/img/logos/155x47/PNG/Groupe6.png"
                : sub
                ? "../assets/img/logos/155x47/PNG/Groupe6.png"
                : "./assets/img/logos/155x47/PNG/Groupe6.png")}`}
              alt="Logo"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-default">
              <i className="bi-list"></i>
            </span>
            <span className="navbar-toggler-toggled">
              <i className="bi-x"></i>
            </span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link link-primary" to="/">
                  {lang("t1")}
                </Link>
              </li>

              <li className="hs-has-mega-menu nav-item">
                <a
                  id="landingsMegaMenu"
                  className="hs-mega-menu-invoker nav-link link-primary dropdown-toggle"
                  aria-current="page"
                  href="#/"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {lang("t2")}
                </a>

                <div
                  className="hs-mega-menu dropdown-menu w-100"
                  aria-labelledby="landingsMegaMenu"
                  style={{ minWidth: "30rem" }}
                >
                  <div className="row">
                    {!isAuth && (
                      <div className="col-lg-3 d-none d-lg-block">
                        <div
                          className="navbar-dropdown-menu-banner"
                          style={{
                            backgroundImage: `url(${
                              sub ? ".." : "."
                            }/assets/img/svg/components/shape-3.svg)`,
                          }}
                        >
                          <div className="navbar-dropdown-menu-banner-content">
                            <div className="mb-4 text-primary">
                              <span className="h2 d-block">
                                {lang("info1")}
                              </span>
                              <p>{lang("info2")}</p>
                            </div>
                            <Link
                              className="btn btn-primary btn-transition"
                              to="/register"
                            >
                              {lang("info3")}
                              <i className="bi-chevron-right small"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className={isAuth ? "col" : "col-lg-9"}>
                      <div className="navbar-dropdown-menu-inner">
                        <div className="row">
                          <div className="col-sm mb-2 flex-list-categ">
                            {objLang.map((categ, index) => (
                              <Link
                                to={`/category/${btoa(categ.link)}`}
                                className="dropdown-item"
                                key={index}
                              >
                                <img
                                  src={`${
                                    sub ? ".." : "."
                                  }/assets/img/svg/icons/${categ.icon}`}
                                  width="24"
                                  height="24"
                                  alt={categ.name}
                                  className="me-2"
                                />
                                <span className="text-truncate">
                                  {categ.name}
                                </span>
                              </Link>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li className="nav-item">
                <Link className="nav-link link-primary " to="/listing">
                  {lang("t3")}
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link link-primary " to="/contact">
                  {lang("t4")}
                </Link>
              </li>

              <li className="nav-item">
                <div
                  className="nav-link link-primary btn btn-ghost-secondary btn-xs "
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasNavbarSearch"
                  style={{ cursor: "pointer" }}
                >
                  <BsSearch size={16} />
                </div>
              </li>

              {pathName.includes("market-place") && (
                <li className="nav-item position-relative">
                  {/* <Link to={"/market-place/cart"} className=" nav-link d-flex "> */}
                  <div
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasNavbarEmptyShoppingCart"
                    className="nav-link btn btn-ghost-secondary btn-xs "
                  >
                    {/* <ShoppingCart className=" text-primary" style={{ cursor: "pointer" }} /> */}
                    <FaShoppingCart
                      size={20}
                      className="  text-primary "
                      style={{ cursor: "pointer" }}
                    ></FaShoppingCart>

                    {getTotalQuantity() > 0 && (
                      <div
                        className="badg  text-white d-flex justify-content-center align-items-center text-center bg-primary border border-white rounded-circle position-absolute "
                        style={{ top: 0, right: -5, paddingBlock: "4px", width: 30  }}
                      >
                        {getTotalQuantity()}
                      </div>
                    )}
                  </div>

                  {/* </Link> */}
                </li>
              )}

              <li className="nav-item">
                <span className="nav-link">
                  <LangSwitcher icon />
                </span>
              </li>

              <li className={`${isAuth && "hs-has-sub-menu"} nav-item`}>
                {isAuth ? (
                  <DropDown></DropDown>
                ) : (
                  <Link className="btn btn-primary btn-transition" to="/login">
                    {lang("t6")}
                  </Link>
                )}
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
